module.exports = {
  sentryEnabled: false,
  coreApi: {
    protocol: "https",
    host: "api-dev-gcp.ct-production.net",
  },
};
